import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-177c12a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal_body" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { key: 3 }
const _hoisted_6 = { class: "membership__list" }
const _hoisted_7 = {
  key: 0,
  class: "check-list"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "check-list__item" }, [
  /*#__PURE__*/_createTextVNode(" List & Manage"),
  /*#__PURE__*/_createElementVNode("strong", null, "Unlimited Properties")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "check-list__item" }, [
  /*#__PURE__*/_createTextVNode(" Access Verified & Local "),
  /*#__PURE__*/_createElementVNode("strong", null, "Trade Contractors")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "check-list__item" }, [
  /*#__PURE__*/_createTextVNode(" Raise & Manage "),
  /*#__PURE__*/_createElementVNode("strong", null, "Any Type of Projects")
], -1))
const _hoisted_11 = [
  _hoisted_8,
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = {
  key: 1,
  class: "check-list"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "check-list__item" }, [
  /*#__PURE__*/_createTextVNode(" Access Subsidised "),
  /*#__PURE__*/_createElementVNode("strong", null, " Up-skilling"),
  /*#__PURE__*/_createTextVNode(" Courses ")
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "check-list__item" }, [
  /*#__PURE__*/_createTextVNode(" Find & Estimate on "),
  /*#__PURE__*/_createElementVNode("strong", null, "New Jobs")
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "check-list__item" }, [
  /*#__PURE__*/_createTextVNode(" Collaborate With "),
  /*#__PURE__*/_createElementVNode("strong", null, "Your Team"),
  /*#__PURE__*/_createTextVNode(" or "),
  /*#__PURE__*/_createElementVNode("strong", null, "Other Trades")
], -1))
const _hoisted_16 = [
  _hoisted_13,
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = {
  key: 4,
  class: "free_trial_card"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Enjoy Free* membership until 1st April 2025", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " On 1st April 2025, your free membership will automatically transition to your selected plan, unless you opt to cancel. ", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Please note:"),
  /*#__PURE__*/_createTextVNode(" Payment card registration is required. ")
], -1))
const _hoisted_21 = [
  _hoisted_18,
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = { class: "plan-cards" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "plan-card__tags" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "plan-card__tag-item" }, "YEARLY"),
  /*#__PURE__*/_createElementVNode("div", { class: "plan-card__tag-item-discount" }, " Most Cost Effective ")
], -1))
const _hoisted_24 = {
  key: 0,
  class: "plan-card__price"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "£0.00"),
  /*#__PURE__*/_createTextVNode("/until 31st March 2025")
], -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "On 1st of April 2025 you'll be charged £95.88 + VAT", -1))
const _hoisted_27 = [
  _hoisted_25,
  _hoisted_26
]
const _hoisted_28 = {
  key: 1,
  class: "plan-card__price"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "£7.99"),
  /*#__PURE__*/_createTextVNode(" per month/ £95.90 today")
], -1))
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "plan-card__tags" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "plan-card__tag-item" }, "MONTHLY")
], -1))
const _hoisted_32 = {
  key: 0,
  class: "plan-card__price"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "£0.00"),
  /*#__PURE__*/_createTextVNode(" / until 31st March 2025")
], -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "On 1st of April 2025 you'll be charged £9.99 + VAT", -1))
const _hoisted_35 = [
  _hoisted_33,
  _hoisted_34
]
const _hoisted_36 = {
  key: 1,
  class: "plan-card__price"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "£9.99"),
  /*#__PURE__*/_createTextVNode(" per month")
], -1))
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = { class: "footer" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Cancel Anytime", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " | ", -1))

import CommonDialog from "@/core/components/CommonDialog.vue";
import { computed, ref } from "vue";
import { cloneObject } from "@/core/utils/common";
import { useStore } from "vuex";
import { USER_STORE } from "@/store/modules/user";
import { WORKSTATION } from "@/store/modules/workstation";
import $axios from "@/core/utils/axios-api-config";
import {
  PaymentPlanType,
  BusinessDetailTypeEnum,
  WorkstationAccountTypeEnum,
  UserWorkstationVerificationType,
  UserVerificationStatusEnum,
  PropertyOwnerWorkstationType,
} from "@/core/enums/RolesEnum";

import {
  VUE_APP_STRIPE_PUBLISHABLE_KEY,
  VUE_APP_SILT_KYC_COMPANY_APP_ID,
} from "@/config";


export default /*#__PURE__*/_defineComponent({
  __name: 'NewWorkstationSubscriptionModal',
  props: {
  isLoading: {
    type: Boolean,
    default: false,
  },
  isProperty: {
    type: Boolean,
    default: false,
  },
},
  emits: [
  "onClickPaymentPlan",
  "closeModal",
  "onClickTermsAndCondition",
],
  setup(__props, { emit: __emit }) {

const emits = __emit;

const props = __props;

const selectedPlan = ref(null);
const planType = ref(PaymentPlanType.YEARLY) as any;
const stripe = ref(null);
const paymentRedirectLoading = ref(false);
const sessionId = ref(null);
const redirectUrl = ref("");
const customer = ref("") as any;
const store = useStore();

const activeUserWorkstation = computed(
  () => store.getters[`${WORKSTATION}/activeUserWorkstation`]
);
const isTrialValid = computed(() => {
  const TRIAL_END_DATE = new Date("2025-03-31");
  const currentDate = new Date();
  const timeDifference = TRIAL_END_DATE.getTime() - currentDate.getTime();
  const daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
  return daysDifference > 0;
});

const oncloseModal = () => {
  if (!props.isLoading) emits("closeModal");
};
const onClickTermsAndCondition = () => {
  if (!props.isLoading) emits("onClickTermsAndCondition");
};
const onClickPlanCard = (plan: any) => {
  selectedPlan.value = plan;
};

const initializeStripePayment = async (
  isTrial: boolean,
  oneTimePayment: boolean,
  price: number
) => {
  stripe.value = initializeStripe();
  paymentRedirectLoading.value = true;
  if (stripe.value) {
    await onCheckout(isTrial, oneTimePayment, price);
  }
  paymentRedirectLoading.value = false;
};
const onCheckout = async (
  isTrial: boolean,
  oneTimePayment: boolean,
  price: number
) => {
  await createSession(isTrial, oneTimePayment, price);
  if (sessionId.value) {
    (stripe.value as any)
      .redirectToCheckout({
        sessionId: sessionId.value,
      })
      .then((result: any) => {
        if (result.error) {
          console.log();
        }
      });
  }
};
const createSession = async (
  isTrial = false,
  oneTimePayment = false,
  price: number
) => {
  const user = cloneObject(store.getters[`${USER_STORE}/user`]);
  const { id: userId, userStripeCustomer, email } = user;

  const productName = "tradesperson-profile";

  const entity = JSON.stringify({
    id: userId,
    name: "tradesperson-profile",
  });

  if (!userStripeCustomer?.length) {
    await $axios
      .post(`/payment/${userId}/customer`, {
        email,
        entity,
      })
      .then(async (customerResponse) => {
        await store.dispatch(`${USER_STORE}/saveUserStripePayment`, [
          customerResponse,
        ]);
        customer.value = customerResponse;
      })
      .catch((e) => {
        console.log();
      });
  } else {
    const [stripeCustomer] = userStripeCustomer;
    customer.value = stripeCustomer;
  }

  const host = `${window.location.protocol}//${window.location.host}`;
  redirectUrl.value = `${host}/dashboard`;

  const { customerId } = customer.value;
  const totalPrice = price;

  if (customerId) {
    await $axios
      .post(`/payment/${userId}/session`, {
        customerId,
        price: totalPrice,
        redirectUrl: redirectUrl.value,
        productName,
        metadata: JSON.stringify({
          userWorkstationId: activeUserWorkstation.value?.id,
          name: activeUserWorkstation.value?.name,
          companyName: activeUserWorkstation.value?.name,
          productName,
          userId,
          businessType: BusinessDetailTypeEnum.PROPERTY_OWNER,
          planType: planType.value,
          workstationAccountType: WorkstationAccountTypeEnum.HOMEOWNER,
          capacity: "100MB",
          totalMember: 1,
        }),
        isTrial,
        oneTimePayment,
      })
      .then(async (sessionResponse: any) => {
        if (sessionResponse) {
          sessionId.value = sessionResponse?.id;
          localStorage.setItem("isShowPOSubScriptionModal", "true");
        }
      })
      .catch((error) => {
        console.log();
      });
  }
};
const initializeStripe = () => {
  let stripe = null;

  if ("Stripe" in window) {
    const { Stripe } = window as any;

    // eslint-disable-next-line no-new
    stripe = new Stripe(VUE_APP_STRIPE_PUBLISHABLE_KEY);
  }

  return stripe;
};

const onClickRegisterPayment = () => {
  if (!selectedPlan.value) return;
  // if (selectedPlan.value) emits("onClickPaymentPlan", selectedPlan.value);

  planType.value = selectedPlan.value;
  if (planType.value === PaymentPlanType.YEARLY) {
    initializeStripePayment(false, false, 95.9);
  } else if (planType.value === PaymentPlanType.MONTHLY) {
    initializeStripePayment(false, false, 9.99);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(CommonDialog, {
    isShowHeader: false,
    isShowBackButton: false,
    width: "570px",
    "max-width": "100%",
    height: "auto",
    persistent: "",
    className: ['new_workstation_subscription_modal']
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_v_icon, {
          onClick: oncloseModal,
          icon: "mdi-close"
        }),
        (__props.isProperty)
          ? (_openBlock(), _createElementBlock("h5", _hoisted_2, "UPGRADE TO PREMIUM"))
          : (_openBlock(), _createElementBlock("h5", _hoisted_3, "Select Your Workstation Membership Plan")),
        (__props.isProperty)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, "Unlock Your Property Superpower Today"))
          : (_openBlock(), _createElementBlock("p", _hoisted_5, " Grow your business - Get quality jobs, manage your operations, and take advantage of subsidised up-skilling courses. ")),
        _createElementVNode("div", _hoisted_6, [
          (__props.isProperty)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_7, _hoisted_11))
            : (_openBlock(), _createElementBlock("ul", _hoisted_12, _hoisted_16))
        ]),
        (isTrialValid.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_21))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_22, [
          _createVNode(_component_v_card, {
            class: _normalizeClass(["plan-card", { selected: selectedPlan.value === _unref(PaymentPlanType).YEARLY }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (onClickPlanCard(_unref(PaymentPlanType).YEARLY)))
          }, {
            default: _withCtx(() => [
              _hoisted_23,
              (isTrialValid.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, _hoisted_27))
                : (_openBlock(), _createElementBlock("div", _hoisted_28, _hoisted_30))
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_component_v_card, {
            class: _normalizeClass(["plan-card", { selected: selectedPlan.value === _unref(PaymentPlanType).MONTHLY }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (onClickPlanCard(_unref(PaymentPlanType).MONTHLY)))
          }, {
            default: _withCtx(() => [
              _hoisted_31,
              (isTrialValid.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_32, _hoisted_35))
                : (_openBlock(), _createElementBlock("div", _hoisted_36, _hoisted_38))
            ]),
            _: 1
          }, 8, ["class"])
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_39, [
        _createVNode(_component_v_btn, {
          class: "button button-purple-border",
          disabled: __props.isLoading,
          onClick: oncloseModal
        }, {
          default: _withCtx(() => [
            _createTextVNode("Cancel")
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_v_btn, {
          class: "button button-purple",
          loading: paymentRedirectLoading.value,
          disabled: __props.isLoading || !selectedPlan.value,
          onClick: onClickRegisterPayment
        }, {
          default: _withCtx(() => [
            _createTextVNode("Register Payment Card")
          ]),
          _: 1
        }, 8, ["loading", "disabled"])
      ]),
      _createElementVNode("div", { class: "sub__footer" }, [
        _hoisted_40,
        _createTextVNode(),
        _hoisted_41,
        _createElementVNode("a", {
          onClick: onClickTermsAndCondition,
          class: "cursor-pointer"
        }, "Terms & Conditions")
      ])
    ]),
    _: 1
  }))
}
}

})